import axios from 'axios';
import qs from 'qs';
import { useNavigate } from 'react-router-dom';
//import { UseConstant } from './UseConstant';

//import { UseLogin } from './UseLogin';

//import i18n from "i18next";

export const UseApi = () => {
    const navigate = useNavigate();

    // コンスタント
    //const { constant } = UseConstant();

    // パラメータ作成(画面)
    const createParamJson = (type, exeUrl, param, attr) => {
        let req = {};
        try {
            req = {
                method: type,
                url: exeUrl,
                cache: attr.cache || false
            };

            if(type === 'GET') {
                req.headers = {};
                req.params = param ? param : null
            } else {
                req.headers = {
                    'content-type': 'application/x-www-form-urlencoded'
                };
                req.data = param ? qs.stringify(param) : null
            }

            if (attr.token) {
                req.headers.Authorization = 'Bearer ' + attr.token;
            }
        } catch {
            alert('内部エラー:Api Parameter Error');
        }
        return req;
    }

    // パラメータ作成(From)
    const createParamForm = (type, exeUrl, param, attr) => {
        let req = {};
        try {
            req = {
                method: type,
                url: exeUrl,
                headers: {
                    'content-type': 'multipart/form-data'
                },
                data: param ? param : null,
                cache: attr.cache ? attr.cache : false
            };
            if (attr.token) {
                req.headers.Authorization = 'Bearer ' + attr.token;
            }
        } catch {
            alert('内部エラー:Api Parameter Error');
        }
        return req;
    }

    // パラメータ作成(Output)
    const createParamOutput = (type, exeUrl, param, attr) => {
        let req = {};
        try {
            req = {
                method: type,
                url: exeUrl,
                headers: {
                    'Authorization': 'Bearer ' + attr.token
                },
                responseType: "blob",
                data: param ? param : null,
                cache: attr.cache ? attr.cache : false
            };
        } catch {
            alert('内部エラー:Api Parameter Error');
        }
        return req;
    }

    /**
     * POST通信
     */
    const postApi = (exeUrl, param, attr, cbSuccess, cbError) => {
        // API実施
        axios(createParamJson('POST', exeUrl, param, attr))
            .then((res) => {
                // 成功時
                if (cbSuccess !== undefined) {
                    cbSuccess(res.data);
                }
            })
            .catch((res) => {
                if(res.response) {
                    if (res.response.status === "401") {
                        // 認証エラー
                        navigate('/sign-in');
                    }
                }
                funcError(res, cbError, attr);
            });
    };

    /**
     * PATCH通信
     */
    const patchApi = (exeUrl, param, attr, cbSuccess, cbError) => {
        // API実施
        axios(createParamJson('PATCH', exeUrl, param, attr))
            .then((res) => {
                // 成功時
                if (cbSuccess !== undefined) {
                    cbSuccess(res.data);
                }
            })
            .catch((res) => {
                if(res.response) {
                    if (res.response.status === "401") {
                        navigate('/sign-in');
                    }
                }
                funcError(res, cbError, attr);
            });
    };

    /**
     * DELETE通信
     */
    const deleteApi = (exeUrl, attr, cbSuccess, cbError) => {
        // API実施
        axios(createParamJson('DELETE', exeUrl, {}, attr))
            .then((res) => {
                // 成功時
                if (cbSuccess !== undefined) {
                    cbSuccess(res.data);
                }
            })
            .catch((res) => {
                if(res.response) {
                    if (res.response.status === "401") {
                        navigate('/sign-in');
                    }
                }
                funcError(res, cbError, attr);
            });
    }

    /**
     * POST通信(FormData)
     */
    const postApiForm = (exeUrl, param, attr, cbSuccess, cbError) => {
        // API実施
        axios(createParamForm('POST', exeUrl, param, attr))
            .then((res) => {
                // 成功時
                if (cbSuccess !== undefined) {
                    cbSuccess(res.data);
                }
            })
            .catch((res) => {
                if (res.response.status === "401") {
                    navigate('/sign-in');
                }
                funcError(res, cbError, attr);
            });
    };

    /**
     * POST通信(Output)
     */
    const postOutputApi = (exeUrl, param, attr, cbSuccess, cbError) => {
        // API実施
        axios(createParamOutput('POST', exeUrl, param, attr))
            .then((res) => {
                // 成功時
                if (cbSuccess !== undefined) {
                    cbSuccess(res);
                }
            })
            .catch((res) => {
                if (res.response.status === "402") {
                    alert('ファイル取得に失敗しました。\n指定フォルダにファイルが存在しない可能性があります。');
                } else {
                    funcError(res, cbError, attr)
                }
            });
    };

    /**
     * GET通信
     */
    const getApi = (exeUrl, param, attr, cbSuccess, cbError) => {
        // API実施
        axios(createParamJson('GET', exeUrl, param, attr))
            .then((res) => {
                // 成功時
                if (cbSuccess !== undefined) {
                    cbSuccess(res.data);
                }
            })
            .catch((res) => funcError(res, cbError, attr));
    };

    /**
     * 例外対応
     * @param {*} res レスポンス
     */
    const funcError = (res, cbError, attr) => {
        // 異常時
        if (axios.isAxiosError(res)) {
            if(res.response) {
                // APIトークンエラーの場合、エラー処理を行わない
                if (res.response.status === 401) {
                    alert('トクンが切れました。再ログインしてください。');
                    navigate('/sign-in');
                    return;
                }
                // APIによるエラー
                alert('XMLHttpRequest : ' + res.response.status + ', textStatus : ' + res.code + ', errorThrown : ' + res.message);
                if (cbError !== undefined) {
                    cbError(res.data);
                }
            } else {
                alert(res?.message)
            }
        } else {
            // JavaScriptによるエラー
            alert('JavaScript ' + res);
        }
    };

    return {
        postApi,
        postApiForm,
        postOutputApi,
        getApi,
        deleteApi,
        patchApi
    };
};
